import { truncateMiddle } from '@seen/core/truncateMiddle'
import { useRef } from 'react'
import { toast } from 'sonner'
import { useDidChange } from '#src/hooks/useDidChange.ts'

export interface UseErrorToastOptions {
  /**
   * If true, skip the visible toast but still `console.error` the message.
   * Use for expected/benign errors (e.g., 410 Gone on stale references)
   * where we want diagnostic logs without noisy UI or intercepted clicks.
   */
  silent?: boolean
}

export function useErrorToast(
  message: string | null | undefined | false,
  { silent = false }: UseErrorToastOptions = {}
): void {
  const isFirstRun = useRef(true)
  const didMessageChange = useDidChange(message)
  if ((isFirstRun.current || didMessageChange) && !!message) {
    const truncated = truncateMiddle(message, { length: 500 })
    if (!silent) {
      toast.error(truncated, {
        id: truncated,
        closeButton: true,
        dismissible: true,
      })
    }
    console.error(message, {
      timestamp: new Date().toISOString(),
      stack: new Error().stack,
      userAgent: navigator.userAgent,
      url: window.location.href,
      online: navigator.onLine,
      silent,
    })
  }
  isFirstRun.current = false
}
